import { Link } from "react-router-dom";
import { ArrowRight, Globe2, HeartHandshake, Lightbulb, Sparkles } from "lucide-react";
import { Reveal, Counter } from "@/components/marketing/kit";

const team = "https://static.prod-images.emergentagent.com/jobs/2a5ce6bc-f8b8-4c59-8aa0-a1d8e1064a9a/images/bb57fc14a4b957f796784134863166bba09eddf7c876960757b0ce1c85666cda.jpeg";
const VALUES = [
  { i: <Lightbulb />, t: "Clarity over complexity", p: "Powerful tools should make decisions simpler — not add another layer of operational noise." },
  { i: <HeartHandshake />, t: "Relationships over transactions", p: "The best creator programs compound because teams remember context and build real trust." },
  { i: <Globe2 />, t: "Global by design", p: "Campaigns cross borders. The workflow supports teams, creators and audiences anywhere." },
  { i: <Sparkles />, t: "AI with judgment", p: "AI accelerates thoughtful work while keeping strategy, taste and final calls in human hands." },
];

export default function About() {
  return (
    <main>
      <section className="mk-sec" style={{ paddingBottom: 40 }}><div className="mk-wrap mk-about-hero">
        <div>
          <Reveal><span className="mk-pill">Our point of view</span></Reveal>
          <Reveal delay={0.08}><h1 className="mk-h2" style={{ fontSize: "clamp(32px,4.6vw,54px)", marginTop: 20 }} data-testid="about-title">From Amsterdam to the AI creator engine for brands worldwide</h1></Reveal>
          <Reveal delay={0.16}><p className="mk-lead" style={{ marginTop: 16 }} data-testid="about-description">We started in Amsterdam, helping European brands find the right creators. Today, HypeFlow AI is the connected workspace global teams use to turn authentic creator relationships into measurable growth.</p></Reveal>
          <Reveal delay={0.24}><div style={{ marginTop: 26 }}><Link to="/login?mode=register" className="mk-btn primary lg" data-testid="about-start-trial">Start free <ArrowRight size={17} /></Link></div></Reveal>
        </div>
        <Reveal delay={0.1} className="mk-about-img"><img src={team} alt="A creative team collaborating on a creator campaign" /></Reveal>
      </div></section>

      <section className="mk-sec" style={{ paddingTop: 0 }}><div className="mk-wrap">
        <div className="mk-ticker" data-testid="about-ticker">
          {[[180, "M+", "creators indexed", 0], [52, "", "markets served", 0], [99.9, "%", "platform uptime", 1], [2400, "+", "brands & agencies", 0]].map(([v, s, l, d]) => (
            <div key={l}><b><Counter to={v} suffix={s} decimals={d} /></b><span>{l}</span></div>
          ))}
        </div>
      </div></section>

      <section className="mk-sec" style={{ paddingTop: 0 }}><div className="mk-wrap">
        <div className="mk-head left" style={{ maxWidth: 640 }}>
          <span className="mk-pill">Why we built it</span>
          <h2 className="mk-h2">A clearer way to work with influence</h2>
          <p>Creators shape how people discover products and decide what deserves attention. But the teams behind those partnerships still waste hours in disconnected databases, spreadsheets and scattered reports. HypeFlow brings it together — discovery informs relationships, relationships inform campaigns, and every result makes the next decision smarter.</p>
        </div>
        <div className="mk-values">{VALUES.map((v, i) => (
          <Reveal key={v.t} delay={i * 0.07}><div className="mk-value" data-testid={`about-value-${i}`}><span className="ic">{v.i}</span><h3>{v.t}</h3><p>{v.p}</p></div></Reveal>
        ))}</div>
      </div></section>

      <section className="mk-sec" style={{ paddingTop: 0 }}><div className="mk-wrap"><div className="mk-cta">
        <span className="mk-pill" style={{ margin: "0 auto" }}>Our belief</span>
        <h2 style={{ maxWidth: 900, margin: "14px auto" }}>Influence isn't a follower count — it's the power to earn attention and move someone to act.</h2>
        <div className="mk-cta-actions"><Link to="/login?mode=register" className="mk-btn primary lg" data-testid="about-final-trial">Start free <ArrowRight size={17} /></Link></div>
      </div></div></section>
    </main>
  );
}
